import { render, staticRenderFns } from "./TianDiTuDemo.vue?vue&type=template&id=4a3e4910&scoped=true&"
import script from "./TianDiTuDemo.vue?vue&type=script&lang=js&"
export * from "./TianDiTuDemo.vue?vue&type=script&lang=js&"
import style0 from "./TianDiTuDemo.vue?vue&type=style&index=0&id=4a3e4910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e4910",
  null
  
)

export default component.exports